import { BaseService } from './base/base.service';
import { endpoints } from './base/endpoints';
import { http } from './base/http';

export class AttachmentService extends BaseService<any> {
  constructor() {
    super(endpoints.attachments.default);
  }

  public async getAttachmentBlobUrl(fileName?: string | null): Promise<string | null> {
    if (!fileName) {
      return null;
    }

    try {
      const response = await http.get(
        `${endpoints.attachments.default}?fileName=${encodeURIComponent(fileName)}`,
        {
          responseType: 'blob',
        }
      );

      const blob = new Blob([response.data], {
        type: response.headers['content-type'] || 'image/jpeg',
      });
      return URL.createObjectURL(blob);
    } catch (error) {
      console.error('Error fetching attachment:', error);
      return null;
    }
  }

  public getAttachmentDirectUrl(fileName?: string | null): string | null {
    if (!fileName) {
      return null;
    }

    const baseUrl = http.defaults.baseURL || '';
    return `${baseUrl}${endpoints.attachments.default}?fileName=${encodeURIComponent(fileName)}`;
  }

  public async getThumbnailUrl(
    thumbnailPath?: string | null,
    fallbackPath: string = '/images/noImage.png'
  ): Promise<string> {
    if (!thumbnailPath) {
      return fallbackPath;
    }

    const blobUrl = await this.getAttachmentBlobUrl(thumbnailPath);
    return blobUrl || fallbackPath;
  }

  public getThumbnailDirectUrl(
    thumbnailPath?: string | null,
    fallbackPath: string = '/images/noImage.png'
  ): string {
    if (!thumbnailPath) {
      return fallbackPath;
    }

    const directUrl = this.getAttachmentDirectUrl(thumbnailPath);
    return directUrl || fallbackPath;
  }
}

export const attachmentService = new AttachmentService();
